import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import CustomDatasetActionDropdownTrigger from './CustomDatasetActionDropdownTrigger';
import CustomDatasetActionDropdownItems from './CustomDatasetActionDropdownItems';

const CustomDatasetActionDropdown = ({ actions }) => (
  <Dropdown
    icon={null}
    trigger={(<CustomDatasetActionDropdownTrigger />)}
    className="aridhia-custom-dataset-action-dropdown"
  >
    <Dropdown.Menu>
      <CustomDatasetActionDropdownItems actions={actions} />
    </Dropdown.Menu>
  </Dropdown>
);

export default CustomDatasetActionDropdown;
